import { render, staticRenderFns } from "./newUniRequestForm.vue?vue&type=template&id=faca21ee&scoped=true&"
import script from "./newUniRequestForm.vue?vue&type=script&lang=js&"
export * from "./newUniRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./newUniRequestForm.vue?vue&type=style&index=0&id=faca21ee&prod&lang=css&"
import style1 from "./newUniRequestForm.vue?vue&type=style&index=1&id=faca21ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faca21ee",
  null
  
)

export default component.exports